import { MutationTree } from 'vuex';
import { ConfigurationState, Environment } from './types';
import { AppTheme } from '@/plugins/vuetify/themes/types';

export const mutations: MutationTree<ConfigurationState> = {
    setTheme(state, theme: AppTheme) {
        state.appTheme = theme;
    },
    setEnvironment(state, environment: Environment) {
        state.environment = environment;
    },
    setAppWindowMode(state, appWindowMode: string) {
        state.appWindowSettings.mode = appWindowMode;
    },
};
